/**
 * Колір ніка в чаті ефіру.
 *
 * Колір не зберігаємо й не роздаємо: він рахується з самого імені, тому в
 * усіх глядачів той самий автор однакового кольору, і після перезапуску
 * бекенда нічого не «перефарбовується».
 *
 * Палітру беремо не випадкову, а фіксовану: у чаті темний фон, і половина
 * випадкових hex-кольорів на ньому просто не читається (темно-сині,
 * коричневі). Це ті самі відтінки, що використовує Twitch, плюс кілька
 * своїх — усі перевірені на контраст із base-300.
 */

// Ті самі відтінки пропонуємо й на екрані налаштувань чату: вибирати з
// перевіреної палітри швидше, ніж ловити читабельний колір піпеткою
export const NICK_COLORS = [
  '#ff7f7f',
  '#ff9d5c',
  '#ffd166',
  '#b8e986',
  '#5cd6a0',
  '#4fd1c5',
  '#6ec9ff',
  '#7aa5ff',
  '#a78bfa',
  '#e07bff',
  '#ff7ac6',
  '#ff8fa3',
  '#c9d36b',
  '#71d88a',
  '#63c7d6',
  '#9fb3ff'
]

// Той самий розкид, що й у CommentAvatar: множимо на просте число і
// беремо код кожної літери, щоб «vasya» і «vasyа» (з іншою «а») не
// злипались в один колір
export const nickColor = (nick) => {
  let hash = 0
  for (const char of String(nick || '')) {
    hash = (hash * 31 + char.codePointAt(0)) % 65536
  }
  return NICK_COLORS[hash % NICK_COLORS.length]
}
